import * as React from "react";
import { Button } from "@material-ui/core";
import { useNavbarStyles } from "../Navbar.styles";

interface IUrlLinkProps {
  url: string;
  closeMenuOnClick?: () => void;
  icon: any;
  title: string;
}

const UrlLink: React.FC<IUrlLinkProps> = (props): JSX.Element => {
  const classes = useNavbarStyles({});
  const { closeMenuOnClick, ...rest } = props;

  return (
    <Button
      {...rest}
      className={classes.menuItem}
      onClick={props.closeMenuOnClick}
      component={"a"}
      href={props.url}
      target={"_blank"}
    >
      {props.title}
      <img src={props.icon} alt="arrow" />
    </Button>
  );
};

export default UrlLink;
